
const TipoPerfil = {
  CONSELHEIRO: {
    id: 1,
    descricao: 'Conselheiro',
    role: 'ROLE_CONSELHEIRO',
    is: (role) => role.startsWith(TipoPerfil.CONSELHEIRO.role)
  },
  EQUIPE_TECNICA: {
    id: 2,
    descricao: 'Equipe Técnica',
    role: 'ROLE_EQUIPE_TECNICA',
    is: (role) => role.startsWith(TipoPerfil.EQUIPE_TECNICA.role)
  },
  INTERLOCUTOR: {
    id: 3,
    descricao: 'Interlocutor',
    role: 'ROLE_INTERLOCUTOR',
    is: (role) => role.startsWith(TipoPerfil.INTERLOCUTOR.role)
  },
};

export default TipoPerfil;
